export const en = {
    clicks: 'Total clicks',
    cost: 'Total expenditure',
    ctr: 'average CTR',
    shows: 'Total impressions'
};
